import { openDB } from 'idb'

/**
 * Initialize the database using idb.
 * @returns {Promise<IDBPDatabase>} The initialized database instance.
 */
const initDB = async () => {
  return openDB('CountdownDB', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('tokenData')) {
        db.createObjectStore('tokenData', { keyPath: 'email' }) // Use email as key
      }
    },
  })
}

/**
 * Get token data for a specific email.
 * @param {string} email - Email associated with the token.
 * @returns {Promise<Object|null>} Token data or null if not found.
 */
export const getTokenData = async email => {
  const db = await initDB()
  return db.get('tokenData', email)
}

/**
 * Set or update token data for a specific email.
 * @param {string} email - Email associated with the token.
 * @param {Object} data - Token data to store (e.g., { tokenExpiresAt, canSendAnNewTokenAt }).
 * @returns {Promise<void>}
 */
export const setTokenData = async (email, data) => {
  const db = await initDB()
  await db.put('tokenData', { email, ...data })
}

/**
 * Remove token data for a specific email.
 * @param {string} email - Email associated with the token.
 * @returns {Promise<void>}
 */
export const removeTokenData = async email => {
  const db = await initDB()
  await db.delete('tokenData', email)
}
